<template>
    <div v-if="componentData" class="small-wrapper grid two">
        <div class="websiteCta">
            <p>{{componentData.ctaTitle}}</p>
            <a :href="componentData.Link" target="_blank">
                <span>
                    <arrow-right/>
                </span>
                {{componentData.buttonLabel}}
            </a>
        </div>
    </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'

import ArrowRight from "../svg/ArrowRight.vue"

export default defineComponent({
    components:{
        ArrowRight
    },
    props:{
        componentData: {
            type: Object,
            required: false
        },
    },
    setup(props) {
        const homeurl: string = import.meta.env.VITE_API_URL;

        return {
            homeurl
        };
    }
})

</script>
